import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import queryString from 'query-string';

import cropStorageImage from 'rebook/apps/utils/urls/cropStorageImage';

import { FacebookIcon, VkIcon } from './images';
import styles from './style.scss';

/**
 * utm_campaign=book (шаринг карточки книги)
 * utm_campaign=audio (шаринг карточки аудиокниги)
 * utm_campaign=author (шаринг страницы автора)
 * utm_campaign=sets (шаринг подборки)
 * utm_campaign=reviews (шаринг страницы отзывов)
 * utm_campaign=citations (шаринг цитат)
 */

class SocialShareMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.getState(props);
  }

  getState(props) {
    const { url, imageUrl, utmCampaign } = props;
    const fbParams = queryString.stringify({
      utm_source: 'socialshare',
      utm_medium: 'facebook',
      utm_campaign: utmCampaign,
    });

    const vkParams = queryString.stringify({
      utm_source: 'socialshare',
      utm_medium: 'vkontakte',
      utm_campaign: utmCampaign,
    });
    const imageSize = utmCampaign === 'sets' ? [1200, 630] : [256, 426];
    const image = imageUrl ? cropStorageImage(imageUrl, imageSize[0], imageSize[1]) : '';
    let fbShareLink = `http://www.facebook.com/sharer.php?u=${url}?${encodeURIComponent(fbParams)}`;
    let vkShareLink = `http://vk.com/share.php?image=${image}&url=${url}?${encodeURIComponent(vkParams)}`;

    return {
      fbShareLink,
      vkShareLink,
      isOpen: false,
    };
  }

  componentDidUpdate(prevProps) {
    const { url: prevUrl, imageUrl: prevImageUrl, utmCampaign: prevUtmCampaign } = prevProps;
    const { url, imageUrl, utmCampaign } = this.props;
    if (prevUrl !== url || imageUrl !== prevImageUrl || utmCampaign !== prevUtmCampaign) {
      this.setState(this.getState(this.props));
    }
  }

  toggleMenu() {
    const { isOpen } = this.state;
    yaMetrikaReachGoal('Share');
    ga('send', 'event', 'MybookEvent InReading', 'Share', 'Choose social networks');
    this.setState({ isOpen: !isOpen });
  }

  handleBlur() {
    this.setState({ isOpen: false });
  }

  handleRef(elem) {
    if (elem) {
      elem.focus();
    }
  }

  handleStopBlur(event, type) {
    event.preventDefault();
    yaMetrikaReachGoal(type === 'VK' ? 'Share_VK' : 'Share_FB');
    ga('send', 'event', 'MybookEvent InReading', 'Share', type === 'VK' ? 'VK' : 'FB');
  }

  render() {
    const { isOpen, fbShareLink, vkShareLink } = this.state;
    const { theme, extraClassName } = this.props;
    return (
      <div className={classNames(styles.menu, extraClassName)}>
        <span
          className={classNames(styles.menuToggle, styles[`theme-${theme}`], 'jest-share-menu')}
          onClick={() => this.toggleMenu()}>
          Поделиться
        </span>
        {isOpen && (
          <div
            tabIndex="-1"
            ref={(elem) => this.handleRef(elem)}
            onBlur={() => this.handleBlur()}
            className={classNames(styles.menuItemList, 'jest-share-menu-is-open')}>
            <a
              onMouseDown={(event) => this.handleStopBlur(event, 'FB')}
              className={classNames(styles.item, 'jest-share-menu-item-fb')}
              href={fbShareLink}
              target="_blank">
              <FacebookIcon className={styles.fbIcon} />
              <div className={styles.linkText}>Facebook</div>
            </a>
            <a
              onMouseDown={(event) => this.handleStopBlur(event, 'VK')}
              className={classNames(styles.item, 'jest-share-menu-item-vk')}
              href={vkShareLink}
              target="_blank">
              <VkIcon className={styles.vkIcon} />
              <div className={styles.linkText}>VKontakte</div>
            </a>
          </div>
        )}
      </div>
    );
  }
};

SocialShareMenu.defaultProps = {
  theme: 'yellow',
  extraClassName: '',
};

SocialShareMenu.propTypes = {
  url: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  utmCampaign: PropTypes.string.isRequired,
  theme: PropTypes.oneOf(['white', 'yellow']),
  extraClassName: PropTypes.string,
};

export default SocialShareMenu;
